module.exports = __webpack_public_path__ + "static/media/32.4a2e73a4.jpg";